import { Avatar } from "@alch/ui";
import { ChevronDown, UserProfile01, UsersProfiles02 } from "@alch/ui/icons/16";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";

import { Path } from "@util/paths";
import { getInitials } from "@util/strings";
import { User } from "../../redux/users";

import { ViewAsPreservingLink } from "@features/common/ViewAsPreservingLink";

const dropdownItems = [
  {
    label: "Profile",
    icon: UserProfile01,
    path: Path.Profile,
  },
  {
    label: "Team",
    icon: UsersProfiles02,
    path: Path.Team,
  },
];

interface HeaderProfileProps {
  user?: User;
}

const preventDefault = (event: Event) => event.preventDefault();

const HeaderProfile = ({ user }: HeaderProfileProps) => {
  const initials = user ? getInitials(user) : undefined;

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>
        <button
          className={clsx(
            "group rounded-full bg-grayscale-50 outline-none transition",
            "-my-1 flex items-center gap-2 py-1 pl-1.5 pr-3",
            "hover:bg-grayscale-100 focus-visible:shadow-focus aria-expanded:bg-grayscale-200",
          )}
          aria-label="Profile dropdown"
        >
          <Avatar
            as="div"
            initials={initials}
            className={clsx(
              "bg-primary-100 text-primary-900",
              "hover:border-transparent group-hover:text-primary-600",
              "group-aria-expanded:bg-primary-500 group-aria-expanded:text-white",
            )}
          />
          <ChevronDown className="text-grayscale-500" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="overflow-hidden rounded-lg border border-grayscale-200 bg-grayscale-50 shadow-gray-lg"
          sideOffset={4}
          align="end"
          style={{ minWidth: 160 }}
          onCloseAutoFocus={preventDefault}
        >
          {dropdownItems.map((item) => (
            <DropdownMenu.Item
              key={item.label}
              asChild
              className={clsx(
                "flex items-center gap-2 p-2 outline-none transition",
                "text-paragraph-200-medium text-grayscale-950",
                "active:bg-grayscale-200 data-[highlighted]:bg-grayscale-100",
              )}
            >
              <ViewAsPreservingLink to={item.path}>
                <item.icon /> {item.label}
              </ViewAsPreservingLink>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default HeaderProfile;
